import { useTranslation } from "react-i18next";
import { Select } from "antd";

const { Option } = Select;

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === 'ar' || lng === 'ckb' ? 'rtl' : 'ltr';
    localStorage.setItem("i18nextLng", lng);
  };

  return (
    <Select
      defaultValue={i18n.language}
      style={{ width: 120 }}
      onChange={changeLanguage}
    >
      <Option value="en">English</Option>
      <Option value="ckb">کوردی</Option>
      <Option value="ar">العربية</Option>
    </Select>
  );
};

export default LanguageSwitcher;
